import { takeLatest } from "redux-saga/effects";
import * as actions from "../../actions";
import { getClientsSaga, getClientTonsSaga, getResultReportSaga  } from "./monitor";

export function* watchMonitorSaga() {
  yield takeLatest(actions.getMonitorClients.type, getClientsSaga);
  yield takeLatest(actions.getClientTons.type, getClientTonsSaga);
  yield takeLatest(actions.getResultReport.type, getResultReportSaga)
}
